export interface OutdatedEntityValue {
  baseData: boolean;
  translations: boolean;
  permissions: boolean;
  settings: boolean;
  [key: string]: boolean;
}
